"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iEditLightAdminRequest = exports.iCreateLightAdminRequest = void 0;
const t = require("io-ts");
exports.iCreateLightAdminRequest = t.interface({
    pathVariables: t.interface({
        projectId: t.number
    }),
    body: t.intersection([
        t.interface({
            projectId: t.number,
            categoryId: t.number,
            name: t.string,
            inviteRightsTo: t.array(t.number)
        }),
        t.partial({
            description: t.union([t.string, t.null, t.undefined])
        })
    ])
});
exports.iEditLightAdminRequest = t.interface({
    pathVariables: t.interface({
        projectId: t.number,
        id: t.number
    }),
    body: t.intersection([
        t.interface({
            name: t.string,
            inviteRightsTo: t.array(t.number)
        }),
        t.partial({
            description: t.union([t.string, t.null, t.undefined])
        })
    ])
});
//# sourceMappingURL=lightAdmin.js.map